import {BenjiKIV} from "../BenjiKIV";
import {BenjiKIVGameAssets} from "../BenjiKIVGameAssets";
import {BenjiKIVSpine} from "../components/BenjiKIVSpine";

/**
 * Created by Jerker Nord on 2022-11-29.
 */

export class BenjiKIVPoolInitialWinAnimations {

    private _spineAnimations:BenjiKIVSpine[];

    public init():void {
        this._spineAnimations = [];
        for(let i:number = 0; i < 30; i++) {
            this._spineAnimations.push(this.createNewAnimation());
        }
    }

    private createNewAnimation():BenjiKIVSpine {
        return new BenjiKIVSpine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.INITIAL_WIN_SYMBOL_SPINE));
    }

    public getAnimation():BenjiKIVSpine {
        for(let i:number = 0; i < this._spineAnimations.length; i++) {
            if(this._spineAnimations[i].isUsed == false) {
                this._spineAnimations[i].isUsed = true;
                return this._spineAnimations[i];
            }
        }
        //console.log("Creating more Initial win Spines!");
        this._spineAnimations.push(this.createNewAnimation());
        return this.getAnimation();
    }

    public getAllUsed():BenjiKIVSpine[] {
        const used:BenjiKIVSpine[] = [];
        for(let i:number = 0; i < this._spineAnimations.length; i++) {
            if(this._spineAnimations[i].isUsed == true) {
                used.push(this._spineAnimations[i]);
            }
        }
        return used;
    }
}